<template>
  <div class="dish-management">
    <!-- 搜索区域 -->
    <div class="search-box">
      <input
        v-model="searchForm.keyword"
        type="text"
        placeholder="搜索菜品名称/描述"
        class="search-input"
        @keyup.enter="getList"
      />
      <input
        v-model="searchForm.openid"
        type="text"
        placeholder="输入用户OpenID"
        class="search-input"
        @keyup.enter="getList"
      />
      <input
        v-model="searchForm.id"
        type="number"
        placeholder="输入菜品ID"
        class="search-input search-input-small"
        @keyup.enter="getList"
      />
      <button class="btn btn-primary" @click="getList" :disabled="loading">
        {{ loading ? '搜索中...' : '搜索' }}
      </button>
      <button class="btn btn-default" @click="resetSearch">重置</button>
    </div>

    <!-- 表格 -->
    <div class="table-box">
      <div v-if="loading" class="loading-mask">
        <div class="loading-spinner"></div>
      </div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>菜品ID</th>
              <th>菜品图片</th>
              <th>菜品名称</th>
              <th>菜品介绍</th>
              <th>价格</th>
              <th>推荐指数</th>
              <th>用户OpenID</th>
              <th>创建时间</th>
              <th>启用状态</th>
              <th>是否私有</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in tableData" :key="item.id">
              <td>{{ item.id }}</td>
              <td class="image-cell">
                <img 
                  v-if="getDishImage(item)" 
                  :src="getDishImage(item)" 
                  class="dish-image"
                  :alt="item.name"
                  @click="copyImageUrl(getDishImage(item))"
                  :title="'点击复制图片链接'"
                  @error="handleImageError(item)"
                />
                <span v-else class="no-image">无图片</span>
              </td>
              <td class="ellipsis" :title="item.name">{{ item.name }}</td>
              <td class="ellipsis" :title="item.description">{{ item.description || '-' }}</td>
              <td class="price">￥{{ formatPrice(item.price) }}</td>
              <td>{{ item.recom }}</td>
              <td class="openid-cell">
                <span class="openid-text ellipsis" :title="item.user_openid">{{ item.user_openid }}</span>
                <button 
                  class="copy-btn" 
                  @click="copyOpenId(item.user_openid)"
                  title="复制OpenID"
                >
                  <svg class="copy-icon" viewBox="0 0 24 24" width="14" height="14">
                    <path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                  </svg>
                </button>
              </td>
              <td class="ellipsis">{{ formatDate(item.created_at) }}</td>
              <td>
                <span :class="['status-tag', item.switchVal ? 'status-success' : 'status-info']">
                  {{ item.switchVal ? '启用' : '关闭' }}
                </span>
              </td>
              <td>
                <span :class="['status-tag', item.is_private ? 'status-danger' : 'status-success']">
                  {{ item.is_private ? '私有' : '公开' }}
                </span>
              </td>
            </tr>
            <tr v-if="tableData.length === 0 && !loading">
              <td colspan="10" class="empty-data">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <div class="pagination-info">
          共 {{ total }} 条
        </div>
        <div class="pagination-controls">
          <select 
            v-model="pageSize" 
            @change="handleSizeChange(pageSize)"
            class="page-size-select"
          >
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
            <option :value="100">100条/页</option>
          </select>
          <button 
            class="page-btn" 
            @click="handleCurrentChange(1)" 
            :disabled="page === 1"
          >
            首页
          </button>
          <button 
            class="page-btn" 
            @click="handleCurrentChange(page - 1)" 
            :disabled="page === 1"
          >
            上一页
          </button>
          <span class="page-info">
            第 {{ page }} / {{ totalPages }} 页
          </span>
          <button 
            class="page-btn" 
            @click="handleCurrentChange(page + 1)" 
            :disabled="page === totalPages"
          >
            下一页
          </button>
          <button 
            class="page-btn" 
            @click="handleCurrentChange(totalPages)" 
            :disabled="page === totalPages"
          >
            尾页
          </button>
          <div class="page-jumper">
            <span>跳至</span>
            <input 
              type="number" 
              v-model.number="jumpPage" 
              @keyup.enter="handleJumpPage"
              class="jump-input"
              :min="1"
              :max="totalPages"
            />
            <span>页</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 复制提示 -->
    <div v-if="copyTipVisible" class="copy-tip">
      {{ copyTipMessage }}
    </div>
  </div>
</template>

<script>
import { getDishList } from '@/api/houtai/dishes.js'

export default {
  name: 'DishManagement',
  data() {
    return {
      // 搜索鏉′欢
      searchForm: {
        keyword: '',
        openid: '',
        id: ''
      },
      // 鍒嗛〉
      page: 1,
      pageSize: 20,
      total: 0,
      // 琛ㄦ牸鏁版嵁
      tableData: [],
      // 鍔犺浇鐘舵€?
      loading: false,
      // 璺宠浆椤电爜
      jumpPage: 1,
      // 澶嶅埗鎻愮ず
      copyTipVisible: false,
      copyTipMessage: '',
      copyTipTimer: null,
      // 鍥剧墖鍔犺浇澶辫触璁板綍
      imageErrors: {}
    }
  },
  computed: {
    // 鎬婚〉鏁?
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1
    }
  },
  created() {
    this.getList()
  },
  beforeUnmount() {
    // 娓呯悊瀹氭椂鍣?
    if (this.copyTipTimer) {
      clearTimeout(this.copyTipTimer)
    }
  },
  methods: {
   // 鑾峰彇鑿滃搧鍒楄〃
  async getList() {
    // 馃敡 淇锛氱‘淇?page 鍜?pageSize 鏄湁鏁堟暟瀛?
    let validPage = parseInt(this.page)
    let validPageSize = parseInt(this.pageSize)
    
    if (isNaN(validPage) || validPage < 1) validPage = 1
    if (isNaN(validPageSize) || validPageSize < 1) validPageSize = 20
    if (validPageSize > 100) validPageSize = 100
    
    // 鍚屾鍥?data 涓?
    if (this.page !== validPage) this.page = validPage
    if (this.pageSize !== validPageSize) this.pageSize = validPageSize
    
    this.loading = true
    try {
      const params = {
        page: validPage,
        pageSize: validPageSize
      }
      
      // 鍙坊鍔犳湁鍊肩殑搜索鍙傛暟
      if (this.searchForm.keyword) params.keyword = this.searchForm.keyword
      if (this.searchForm.openid) params.openid = this.searchForm.openid
      if (this.searchForm.id) params.id = this.searchForm.id
      
      console.log('鍙戦€佸弬鏁?', params) // 璋冭瘯鐢?
      
      const res = await getDishList(params)
      
      // 馃敡 淇锛氭牴鎹疄闄呰繑鍥炵粨鏋勮В鏋愭暟鎹?
      if (res && res.status === 200) {
        this.tableData = res.data || []
        this.total = res.total || 0
        this.imageErrors = {}
      } else if (res && res.data && res.data.status === 200) {
        // 鍏煎鍙兘澶氬寘涓€灞傜殑鎯呭喌
        this.tableData = res.data.data || []
        this.total = res.data.total || 0
      } else {
        console.warn('鏈煡鐨勬暟鎹粨鏋?', res)
        this.tableData = []
        this.total = 0
      }
      
      console.log('鑾峰彇鑿滃搧鍒楄〃鎴愬姛:', res)
      console.log('琛ㄦ牸鏁版嵁鏉℃暟:', this.tableData.length, '鎬绘暟:', this.total)
      
    } catch (error) {
      console.error('鑾峰彇鏁版嵁澶辫触:', error)
      alert('获取数据失败：' + (error.message || '未知错误'))
    } finally {
      this.loading = false
    }
  },

// 鍒嗛〉澶у皬鍙樺寲
handleSizeChange(newSize) {
  // 鐩存帴鎷垮埌缁戝畾鐨勫€?
  newSize = parseInt(newSize)
  
  if (isNaN(newSize) || newSize < 1) {
    newSize = 20
  }
  if (newSize > 100) {
    newSize = 100
  }
  
  this.pageSize = newSize
  this.page = 1
  this.getList()
},

  // 椤电爜鍙樺寲
  handleCurrentChange(page) {
    let newPage = parseInt(page)
    if (isNaN(newPage)) newPage = 1
    if (newPage < 1) newPage = 1
    if (newPage > this.totalPages) newPage = this.totalPages
    this.page = newPage
    this.getList()
  },

  // 璺宠浆椤电爜
  handleJumpPage() {
    let page = parseInt(this.jumpPage)
    if (isNaN(page) || page < 1) page = 1
    if (page > this.totalPages) page = this.totalPages
    this.page = page
    this.jumpPage = page
    this.getList()
  },

  // 重置搜索
  resetSearch() {
    this.searchForm = {
      keyword: '',
      openid: '',
      id: ''
    }
    this.page = 1
    this.pageSize = 20  // 馃敡 纭繚重置 pageSize
    this.jumpPage = 1
    this.getList()
  },
    copyOpenId(openid) {
      if (!openid) {
        this.showCopyTip('OpenID为空，无法复制', 'error')
        return
      }

      this.copyToClipboard(openid, 'OpenID')
    },

    copyImageUrl(imageUrl) {
      if (!imageUrl) {
        this.showCopyTip('图片链接为空，无法复制', 'error')
        return
      }

      this.copyToClipboard(imageUrl, '图片链接')
    },

    getDishImage(item) {
      if (!item || this.imageErrors[item.id]) return ''
      return item.image_url || item.image || item.img || ''
    },

    async copyToClipboard(text, type) {
      try {
        await navigator.clipboard.writeText(text)
        this.showCopyTip(`${type}复制成功`, 'success')
      } catch (err) {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          this.showCopyTip(`${type}复制成功`, 'success')
        } catch (e) {
          this.showCopyTip(`${type}复制失败，请手动复制`, 'error')
        }
        document.body.removeChild(textarea)
      }
    },

    showCopyTip(message, type = 'success') {
      if (this.copyTipTimer) {
        clearTimeout(this.copyTipTimer)
      }
      
      this.copyTipMessage = message
      this.copyTipVisible = true
      
      if (type === 'error') {
        this.copyTipMessage = '错误：' + message
      } else {
        this.copyTipMessage = '成功：' + message
      }
      
      this.copyTipTimer = setTimeout(() => {
        this.copyTipVisible = false
      }, 2000)
    },

    // 鍥剧墖鍔犺浇澶辫触澶勭悊
    handleImageError(item) {
      if (!this.imageErrors[item.id]) {
        this.$set(this.imageErrors, item.id, true)
        // 鍙互閫夋嫨璁剧疆涓€涓粯璁ゅ浘鐗?
        // item.image_url = '/default-image.png'
      }
    },

    // 鏍煎紡鍖栦环鏍?
    formatPrice(price) {
      return Number(price).toFixed(2)
    },

    // 鏍煎紡鍖栨棩鏈?
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.dish-management {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 80px);
  position: relative;
}

/* 搜索鍖哄煙 */
.search-box {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.search-input {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  width: 260px;
}

.search-input:focus {
  border-color: #409eff;
}

.search-input-small {
  width: 200px;
}

/* 鎸夐挳鏍峰紡 */
.btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.btn-primary {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.btn-primary:hover:not(:disabled) {
  background: #66b1ff;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-default {
  background: #fff;
  color: #606266;
  border-color: #dcdfe6;
}

.btn-default:hover {
  background: #f5f7fa;
}

/* 琛ㄦ牸鍖哄煙 */
.table-box {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: relative;
}

.table-wrapper {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table th,
.data-table td {
  border: 1px solid #ebeef5;
  padding: 12px 8px;
  text-align: left;
}

.data-table th {
  background: #f5f7fa;
  color: #2d4054;
  font-weight: 600;
  white-space: nowrap;
}

.data-table td {
  color: #606266;
}

.data-table tbody tr:hover {
  background: #f5f7fa;
}

.ellipsis {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price {
  color: #f56c6c;
  font-weight: 500;
}

/* 鍥剧墖鍗曞厓鏍兼牱寮?*/
.image-cell {
  text-align: center;
  width: 80px;
}

.dish-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #ebeef5;
}

.dish-image:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.no-image {
  color: #c0c4cc;
  font-size: 12px;
}

/* OpenID 鍗曞厓鏍兼牱寮?*/
.openid-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.openid-text {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
}

.copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: transparent;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  color: #909399;
  transition: all 0.2s;
  flex-shrink: 0;
}

.copy-btn:hover {
  color: #409eff;
  border-color: #409eff;
  background: #ecf5ff;
}

.copy-icon {
  display: block;
}

/* 鐘舵€佹爣绛?*/
.status-tag {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-success {
  background: #f0f9eb;
  color: #67c23a;
}

.status-info {
  background: #f4f4f5;
  color: #909399;
}

.status-danger {
  background: #fef0f0;
  color: #f56c6c;
}

.empty-data {
  text-align: center;
  padding: 40px !important;
  color: #909399;
}

/* 鍔犺浇鍔ㄧ敾 */
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 鍒嗛〉鏍峰紡 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.pagination-info {
  font-size: 14px;
  color: #606266;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-size-select {
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  background: #fff;
}

.page-btn {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  color: #606266;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #606266;
}

.page-jumper {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #606266;
}

.jump-input {
  width: 60px;
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
  outline: none;
}

.jump-input:focus {
  border-color: #409eff;
}

/* 澶嶅埗鎻愮ず */
.copy-tip {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px 16px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 14px;
  z-index: 2000;
  animation: slideIn 0.3s ease;
  border-left: 4px solid #67c23a;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 绉诲姩绔€傞厤 */
@media (max-width: 768px) {
  .search-box {
    flex-direction: column;
  }
  
  .search-input,
  .search-input-small,
  .btn {
    width: 100% !important;
  }
  
  .pagination-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .pagination-controls {
    width: 100%;
    justify-content: center;
  }
  
  .data-table th,
  .data-table td {
    padding: 8px 4px;
    font-size: 12px;
  }
  
  .openid-cell {
    min-width: 180px;
  }
  
  .copy-tip {
    top: 10px;
    right: 10px;
    left: 10px;
    text-align: center;
  }
  
  .dish-image {
    width: 40px;
    height: 40px;
  }
  
  .image-cell {
    width: 60px;
  }
}
</style>
